import { accountKeys } from '@taler/api-client'
import { useQuery } from '@tanstack/vue-query'
import { computed, type ComputedRef } from 'vue'
import { useApi } from '@/app/api'
import { giftsAccountId } from '../internal/gifts-account.ts'

export interface UseGiftsAccountOptions {
  readonly ledgerId: () => string
  readonly enabled: () => boolean
}

/** The ledger's default write-off target for a forgiven contact receivable. */
export function useGiftsAccount(options: UseGiftsAccountOptions): ComputedRef<string | undefined> {
  const api = useApi()
  const tree = useQuery({
    queryKey: computed(() => accountKeys.tree(options.ledgerId())),
    queryFn: ({ signal }) => api.accounts.tree(options.ledgerId(), signal),
    enabled: computed(options.enabled),
  })
  return computed(() => (tree.data.value === undefined ? undefined : giftsAccountId(tree.data.value)))
}
